<template>
  <div id="app">
    <div class="wapper">
      <header class="header">
        <nav-bars></nav-bars>
      </header>
      <router-view ></router-view>
    </div>
    
  </div>
</template>

<script>
import NavBars from './components/Nav/NavBars.vue'


export default {
  components: { NavBars },
  name: 'App',

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
